import styled, { css } from '../../styled-components';
import { Label } from '../typography/label/Label';
import { media } from '../../styles/media';
import { touchSupport } from '../../utils';

interface ContainerProps {
  checked?: boolean;
  disabled?: boolean;
  error?: boolean;
}

export const Container = styled.div<ContainerProps>`
  transition: color 0.25s, border-color 0.25s, transform 0.25s;
  position: relative;
  height: 22px;
  width: 22px;
  border: 1px solid ${({ theme }) => theme.color.silver};
  background-color: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.silver};
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;

  flex-shrink: 0;
  flex-grow: 0;

  > input {
    width: 22px;
    height: 22px;
    opacity: 0;
    cursor: pointer;
  }

  ::after {
    content: '';
    position: absolute;
    transition: width 0.25s, height 0.25s;
    border-radius: 50%;
    pointer-events: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    background: ${({ theme }) => theme.color.blue};
  }

  ${({ checked }) =>
    checked
      ? css`
          pointer-events: none;
          color: ${({ theme }) => theme.color.blue};
          border-color: ${({ theme }) => theme.color.blue};

          ::after {
            width: 11px;
            height: 11px;
          }
        `
      : !touchSupport &&
        media.md`
          &:hover,
          &:focus {
            transform: scale(1.1);
          }
        `}

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.color.error};
      border-color: ${({ theme }) => theme.color.error};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      color: ${({ theme }) => theme.color.silver};
      background-color: ${({ theme }) => theme.color.alabaster};
      border-color: ${({ theme }) => theme.color.silver};

      ::after {
        background-color: ${({ theme }) => theme.color.silver};
      }
    `}
`;

interface CheckedLabelProps {
  checked?: boolean;
}

export const StyledLabel = styled(Label)<CheckedLabelProps>`
  margin-left: ${({ theme }) => theme.spacing.s};
  margin-top: 2px;
  user-select: none;

  ${media.md`
    margin-top: 0;
  `}

  ${({ checked }) =>
    checked &&
    css`
      font-weight: 700;
    `}
`;

interface GroupProps {
  hasLabel: boolean;
  disabled?: boolean;
}

export const RadioButtonContainer = styled.div<GroupProps>`
  display: flex;
  padding: 2px 0;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({ hasLabel }) =>
    hasLabel &&
    media.md`
      ${Container} {
        margin-top: ${({ theme }) => theme.spacing.xs};
      }
    `}
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
`;
